import { getSuperCookie, setSuperCookie } from 'stash/utils/superCookie';

export type SavedMix = {
	mixName: string;
	prompt: string;
};

const trimString = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

export function getSavedMix(): SavedMix {
	const cookie = getSuperCookie();
	return {
		mixName: trimString(cookie?.mixName),
		prompt: trimString(cookie?.prompt),
	};
}

// Any successful portfolio-builder buy drops the saved mix, whether or not
// this purchase used it. The portfolio-builder entry theme is part of that
// handoff, so it goes too. Other themes and attribution stay. A cookie with
// no saved mix is left untouched so attribution is not rewritten.
export function clearSavedMix(): void {
	const cookie = getSuperCookie();
	if (!cookie) return;

	const saved = {
		mixName: trimString(cookie.mixName),
		prompt: trimString(cookie.prompt),
	};
	if (!saved.mixName && !saved.prompt) return;

	const next = { ...cookie };
	delete next.mixName;
	delete next.prompt;
	if (next.theme === 'portfolio-builder') {
		delete next.theme;
	}
	setSuperCookie(next);
}
